<template>
  <TMainForm :script-id="scriptId" :interception="interception" :buttons="buttons" :default-design="defaultDesign"
    :default-change-script="defaultChangeScript" :default-proccess-script="defaultProccessScript" />
</template>

<script setup>
/**
 * TTMWellClusterForm 
 */
import TMainForm from './TMainForm.vue';
import { FORM_DESIGNS, FORM_CHANGE_SCRIPTS, FORM_PROCESS_SCRIPTS } from './constants';

const props = defineProps({
  scriptId: { type: Number, default: null },
  interception: { type: [String, Object, Boolean], default: null },
});

const buttons = [];
const defaultDesign = FORM_DESIGNS.TTMWellClusterForm;
const defaultChangeScript = FORM_CHANGE_SCRIPTS.TTMWellClusterForm;
const defaultProccessScript = FORM_PROCESS_SCRIPTS.TTMWellClusterForm;
</script>
